import LabelLocation from '@/public/img/label-location.webp';
import UnitLabel from '@/public/img/unit-label.webp';
import Image from 'next/image';

export interface ImageStepExamplesProps {
	testId?: string;
}

const ImageStepExamples = (props: ImageStepExamplesProps) => {
	const { testId = 'ImageStepExamples' } = props;

	return (
		<div
			data-testid={testId}
			className="hvac-container mb-14 text-center lg:mb-18"
		>
			<div className="mx-auto flex w-full items-stretch justify-center gap-2 lg:gap-6">
				<figure className="flex w-full max-w-60 flex-col items-center">
					<Image
						className="rounded-3xl object-cover"
						src={LabelLocation}
						alt="Label location in unit"
					/>
					<figcaption className="mt-2 text-xs text-slate-500 md:text-sm lg:mt-4">
						Step 1: Find your label
					</figcaption>
				</figure>

				<figure className="flex w-full max-w-60 flex-col items-center">
					<Image
						className="rounded-3xl object-cover"
						src={UnitLabel}
						alt="Unit label"
					/>
					<figcaption className="mt-2 text-xs text-slate-500 md:text-sm lg:mt-4">
						Step 2: Upload label photo
					</figcaption>
				</figure>
			</div>
		</div>
	);
};

export default ImageStepExamples;
